import { render, staticRenderFns } from "./Dateformat.vue?vue&type=template&id=ce82c482"
import script from "./Dateformat.vue?vue&type=script&lang=js"
export * from "./Dateformat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports